export default function () {
  return {
    roles: [],
    allroles: [],
    rolesCurrentPage: 1,
    rolesLastPage: 1,
    rolesPerPage: 0,
    rolesTotal: 0,
    rolesLoading: false,
    indexPage: null
  }
}
